<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-clock" :label="!isSmallerScreen ? 'Pontualidade' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <Attendance />
      </div>
    </vs-tab>

    <!-- <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Grau de competência' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <Proficiency />

      </div>
    </vs-tab> -->
  </vs-tabs>
</template>

<script>

// import UserSettingsGeneral from "./UserSettingsGeneral.vue"
import Attendance from "./Attendance.vue"
import Proficiency from "./Proficiency.vue"

// import Permissoes from "./Permissoes.vue"
import { PermissionsMixin } from "../../../mixins/permissions"

export default {
  mixins: [PermissionsMixin],
  components: {
    //    UserSettingsGeneral,
    Attendance,
    Proficiency,
    // Permissoes,
  },
  data() {
    return {

    }
  },
  mounted() {
    this.verifyRoles()
  },
  computed: {
    isSmallerScreen() {
      this.verifyRoles()
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
